import { useRoutesContext } from '@partnerconnect-monorepo/shared/context/routesContext';
import { usePageTracking } from '@partnerconnect-monorepo/shared/hooks/usePageTracking';
import { routes } from './routes';

export function App() {
  usePageTracking();
  useRoutesContext(routes);

  return null;
}

export default App;
